export interface DataTableField {
  name: string;
  type: 'text' | 'multiline' | 'image';
  hidden?: boolean;
  deletable?: boolean;
}

export const DEFAULT_DEFINABLE_FIELDS: DataTableField[] = [
  { name: 'Image', type: 'image', hidden: false, deletable: false },
  { name: 'Name', type: 'text', hidden: false, deletable: false },
  { name: 'Role', type: 'text', hidden: false, deletable: false },
  { name: 'Location', type: 'text', hidden: false, deletable: false },
];

export interface DataTableSnapshot {
  fields: DataTableField[];
  values: any[][];
  source: string | null;
  account: string | null;
  name: string;
  hideFirstRow: boolean;
}

export type DataTableLoadContent = () => DataTableSnapshot;
export type DataTableSaveContent = (snapshot: DataTableSnapshot) => void;
